import { register } from '@/services/registration-service/registration.service';
import { useJWT } from '../use-jwt/use-jwt';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { openNotification } from '@/utils/notification/notification';
import { AxiosErrorResponse } from '@/services/request/request.types';

export const useRegistration = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const { saveToken } = useJWT();

  const {
    mutateAsync: registerUser,
    error: registrationError,
    isPending: isRegistering,
  } = useMutation({
    mutationFn: register,
    onSuccess: () => {
      saveToken({ token: 'cookie' });
      navigate('/onboarding/plan');
    },
    onError: (error: AxiosErrorResponse) => {
      const errors = error.response?.data?.errors;
      const message =
        typeof errors === 'string'
          ? errors
          : Array.isArray(errors)
            ? errors.join('. ')
            : t('signUp.failed');

      openNotification({ message, type: 'error' });
      return error;
    },
  });

  return {
    registerUser,
    registrationError,
    isRegistering,
  };
};
